import {
  type MutationKey,
  type UseMutationOptions,
  useMutation,
} from "@tanstack/react-query";
import type { AxiosError } from "axios";
import type { ApiError } from "./useApi";

type ApiMutationConfig<TData, TVariables, TError> = {
  mutationOptions: Omit<
    UseMutationOptions<TData, AxiosError<TError>, TVariables, unknown>,
    "mutationKey"
  > & {
    mutationKey: MutationKey;
  };
};

export function useApiMutation<TData, TVariables, TError = ApiError>({
  mutationOptions,
}: ApiMutationConfig<TData, TVariables, TError>) {
  return useMutation<TData, AxiosError<TError>, TVariables>({
    ...mutationOptions,
  });
}
